import { createBrowserRouter, Outlet } from "react-router-dom";

import { routesFor } from "@/features/registry";

import { AccountPage } from "./auth/AccountPage";
import { ForgotPage } from "./auth/ForgotPage";
import { LoginPage } from "./auth/LoginPage";
import { ResetPasswordPage } from "./auth/ResetPasswordPage";
import { SetupPage } from "./auth/SetupPage";
import { AppLayout } from "./AppLayout";
import { HomeRedirect, PublicOnly, RequireSession, RequireSurface, SetupOnly } from "./guards";
import { NotFound } from "./NotFound";
import { RouteError } from "./RouteError";
import { SessionProvider } from "./session";

function Root() {
  return (
    <SessionProvider>
      <Outlet />
    </SessionProvider>
  );
}

export const router = createBrowserRouter([
  {
    element: <Root />,
    errorElement: <RouteError />,
    children: [
      {
        path: "/login",
        element: (
          <PublicOnly>
            <LoginPage />
          </PublicOnly>
        ),
      },
      { path: "/forgot", element: <ForgotPage /> },
      { path: "/reset-password", element: <ResetPasswordPage /> },
      {
        path: "/2fa/setup",
        element: (
          <SetupOnly>
            <SetupPage />
          </SetupOnly>
        ),
      },
      {
        element: <RequireSession />,
        children: [
          {
            element: <AppLayout />,
            children: [
              {
                errorElement: <RouteError />,
                children: [
                  { path: "/", element: <HomeRedirect /> },
                  { path: "/account", element: <AccountPage /> },
                  { path: "/admin", element: <RequireSurface surface="admin" />, children: routesFor("admin") },
                  { path: "/portal", element: <RequireSurface surface="portal" />, children: routesFor("portal") },
                  { path: "*", element: <NotFound /> },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]);
